import Axios from './axios';
import Mappings from './api.mappings';
export class ExternalLinkApi {
    sheet(params) {
        return Axios.get(Mappings.externalLink.sheet, { params });
    }
    /**
     * 根据url获取图片文件流
     * @param string 图片获取地址
     */
    generateQrcode(string) {
        const params = {
            text: string
        };
        return Axios.get(Mappings.externalLink.generateQrcode, {
            params,
            responseType: 'arraybuffer'
        });
    }
    getShortCode(params) {
        return Axios.post(Mappings.externalLink.getShortCode, params);
    }
}
